
import React from "react";
import { motion } from "framer-motion";

export const OurNameSection = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4 max-w-5xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-playfair font-bold text-[#1A1F2C] mb-6">
            Our Name, Our Mission
          </h2>
          
          <motion.p 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto"
          >
            "Selah" means to pause and reflect—to listen for what God is saying.
          </motion.p>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            That's what this app is. A pause. A breath. A space where Scripture comes alive in your context. 
            Where truth cuts through the fog. Where clarity is just a tap away.
          </p>
        </motion.div>
      </div>
    </section>
  );
};
